const SCRIPT_SRC = 'https://js.paystack.co/v1/inline.js';

let loadPromise = null;

/** Lazy-loads Paystack's Inline JS SDK once, on first use. */
export function loadPaystackInline() {
  if (window.PaystackPop) return Promise.resolve(window.PaystackPop);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve(window.PaystackPop);
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Could not load Paystack checkout. Check your connection and try again.'));
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}

export function generateReference(prefix = 'piua') {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}
